<template>
    <kgr-form-scaffold
        :pending="pending"
        :pending-delete="pendingRemove"
        :with-delete-button="isDeletable"
        :with-primary-buttons="isEditable"
        edit-mode
        @primaryBtnClicked="updateTeam"
        @deleteBtnClicked="removeTeam"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-team-data-provider
            :team-id="teamId"
            :callback="onTeamLoaded"
        >
            <div class="animated fadeIn">
                <kgr-team-basic-data-form
                    :team="team"
                    :club-id="clubId"
                    :error="error"
                    @enter="updateTeam"
                />
            </div>
        </kgr-team-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import KgrTeamBasicDataForm from '../../components/team/TeamBasicDataForm';
import TeamDataProvider from '../../components/data-provider/TeamDataProvider';
import TeamRepository from '../../js/repository/TeamRepository';

export default {
    components: {
        KgrTeamBasicDataForm,
        'kgr-team-data-provider': TeamDataProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        teamId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            pendingRemove: false,
            error: new Error(),
            team: null,
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onTeamLoaded(loadedTeam) {
            this.team = loadedTeam;
        },
        removeTeam() {
            showConfirm(this.$t('confirmInformal'), this.$t('team.confirm.delete', {'name': this.team.name}), () => {
                this.pendingRemove = true;
                TeamRepository.delete(this.team.id)
                    .then(() => {
                        this.error = new Error();
                        this.$notify.success('team.delete.success', {'name': this.team.name}, { saveInSession: true });
                        this.redirectToOverview();
                    })
                    .catch(error => {
                        if (error.status === 409) {
                            this.$notify.error('team.delete.conflict', {'name': this.team.name});
                        } else {
                            this.$notify.error('saveChanges.error')
                        }

                        this.handleError(error);
                        this.pendingRemove = false
                    });
            }, 'Ok');
        },
        updateTeam() {
            if (!this.isEditable) {
                return;
            }
            this.pending = true;
            TeamRepository.update(this.team)
                .then(() => {
                    this.$notify.success('saveChanges.success', {}, { saveInSession: true });
                    window.location = `/backend/clubs/teams/${this.teamId}/basicData`;
                })
                .catch(error => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
